import axios from 'axios';

import { isProductionEnvironment, isStageEnvironment } from 'utils/environment';
import { OFDSettingsData } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/mock/ofd-settings.mock';
import {
  ConsumptionRateOptions,
  FeedReserve,
  FeedRunOut,
  InventoryLog,
  OfdSettings,
  Timeline,
} from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/ofd-settings.type';

// GET: Fetch OFD Site data (settings)
// /ewosapi/v1/recommendations/site-data?globalSiteId=${globalSiteId}
export const getOfdSettings = async (globalSiteId: string): Promise<OfdSettings> => {
  if (!isProductionEnvironment && !isStageEnvironment) return OFDSettingsData; // return mock data in non prod environments until issue with CDC can be resolved.

  const res = await axios.get<OfdSettings>(`/ewosapi/v1/recommendations/site-data?globalSiteId=${globalSiteId}`);
  return res.data;
};

export const getFeedRunOutDate = async (globalSiteId: string): Promise<FeedRunOut> => {
  const res = await axios.get<FeedRunOut>(`/ewosapi/v1/recommendations/when-will-feed-run-out?globalSiteId=${globalSiteId}`);
  return res.data;
};

// GET: Inventoy log events
// /ewosapi/v1/recommendations/inventory-log
// /ewosapi/v1/recommendations/inventory-log?globalSiteId=${globalSiteId}

export const getInventoryLog = async (globalSiteId: string): Promise<InventoryLog[]> => {
  // return mockInventoryLogResponse;
  const res = await axios.get(`/ewosapi/v1/recommendations/inventory-log?globalSiteId=${globalSiteId}`);
  return res.data;
};

//Get: Feed strategy
// /ewosapi/v1/recommendations/feed-strategy
export const getFeedStrategy = async (globalSiteId: string): Promise<FeedReserve[]> => {
  // return mockFeedReserveRequest;
  const res = await axios.get(`/ewosapi/v1/recommendations/feed-strategy?globalSiteId=${globalSiteId}`);
  return res.data;
};

//Get: Consumption Rate Options
// /ewosapi/v1/recommendations/settings/consumption-rate-options?globalSiteId=${globalSiteId}
// /ewosapi/v1/recommendations/settings/consumption-rate-options
export const getConsumptionRateOptions = async (
  globalSiteId: string,
  ignoreStarvation: boolean
): Promise<ConsumptionRateOptions[]> => {
  // return mockConsumptionRate;
  const res = await axios.get(
    `/ewosapi/v1/recommendations/settings/consumption-rate-options?globalSiteId=${globalSiteId}&ignoreStarvation=${ignoreStarvation}`
  );
  return res.data;
};

// GET: Timeline
// /ewosapi/v1/Recommendations/timeline
// /ewosapi/v1/Recommendations/timeline?globalSiteId=${globalSiteId}
export const getTimeline = async (globalSiteId: string, nrOfDays: number): Promise<Timeline> => {
  // return timelineMockChartData;
  const res = await axios.get(`/ewosapi/v1/recommendations/timeline?globalSiteId=${globalSiteId}&nrOfDays=${nrOfDays}`);
  return res.data;
};
